import axios from "../lib/utils/axios";

// Format nested params correctly
axios.interceptors.request.use(config => {
  config.paramsSerializer = {
    indexes: true
  }

  return config;
});

const Api = {
  baseURL: '',
  version: '',

  erpPath: '/fans/:id/erp',
  graphPath: '/fans/:id/graph',
  infoPath: '/fans/:id/info',
  acousticPath: '/fans/:id/acoustic',
  resistivePath: '/fans/:id/resistive',

  acoustic(id, points, distance, type, directionality, units) {
    const url = Api.buildUrl(this.acousticPath).replace(':id', encodeURIComponent(id));

    return axios.get(url, { params: { points, distance, type, directionality, units } })
  },

  erp(id, variantId, curveId, motorId) {
    const url = Api.buildUrl(this.erpPath).replace(':id', encodeURIComponent(id));

    return axios.get(url, { params: { variant_id: variantId, curve_id: curveId, motor_id: motorId } })
  },

  fanInfo(id, fields, extra = {}) {
    const url = Api.buildUrl(this.infoPath).replace(':id', encodeURIComponent(id));

    return axios.get(url, { params: { fields, extra } })
  },

  graph(id, designPoint, units) {
    const url = Api.buildUrl(this.graphPath).replace(':id', encodeURIComponent(id));

    return axios.get(url, { params: { ...designPoint, units } })
  },

  resistive(id, designPoint, units) {
    const url = Api.buildUrl(this.resistivePath).replace(':id', encodeURIComponent(id));

    return axios.get(url, { params: { ...designPoint, units } })
  },

  setBaseUrl(baseURL) {
    this.baseURL = baseURL;
  },

  buildUrl(url) {
    return [this.baseURL || '', url.replace(':version', this.version)].join("");
  },

};

export default Api;
